module.exports = __webpack_public_path__ + "img/12.35fc744c.png";